import Vue from 'vue'

import ShopItemsList from './ShopGroup/ShopItemsList.vue'
import ShopPage from './ShopPage/ShopProducts.vue'
import SearchResult from './SearchResult.vue'
import ShopItemPrices from './ShopGroup/Cart/ShopItemPrices.vue'
import ShopItemPricesBuy from './ShopItem/ShopItemPrices.vue'
import CartNavbar from './Cart/CartNavbar.vue'
import Cart from './Cart/Cart.vue'
import RelatedShopItems from './ShopItem/RelatedShopItems'
import RelatedMenu from './ShopItem/RelatedMenu'

import Callback from './../Callback.vue'
Vue.component('callback-form',Callback);

Vue.component('cart-navbar', CartNavbar);
Vue.component('search-result', SearchResult);
Vue.component('cart', Cart);
Vue.component('shop-items-list', ShopItemsList);
Vue.component('related-shop-items', RelatedShopItems);
Vue.component('related-menu', RelatedMenu);
Vue.component('shop-item-prices', ShopItemPrices);
Vue.component('shop-item-prices-buy', ShopItemPricesBuy);
Vue.component('shop-page', ShopPage);



// WEBPACK FOOTER //
// ./components/Shop/index.js